import { render, staticRenderFns } from "./DispatchReport.vue?vue&type=template&id=59fa39fa&scoped=true&"
import script from "./DispatchReport.vue?vue&type=script&lang=js&"
export * from "./DispatchReport.vue?vue&type=script&lang=js&"
import style0 from "./DispatchReport.vue?vue&type=style&index=0&id=59fa39fa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59fa39fa",
  null
  
)

export default component.exports